import fetchLoyaltyAccountActivity from 'actions/loyalty/fetchLoyaltyAccountActivity'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { EmptyArray } from 'lib/array/arrayUtils'
import moment from 'moment'
import { useCallback, useEffect, useRef } from 'react'

const startDate = moment().subtract(2, 'year').format(ISO_DATE_FORMAT)
const endDate = moment().add(1, 'year').format(ISO_DATE_FORMAT)

function useCurrentLoyaltyActivities(): [
  activities: Array<App.LoyaltyAccountActivity>,
  fetching: boolean,
  hasNextPage: boolean,
  loadMore: () => void,
  error: any,
] {
  const dispatch = useAppDispatch()
  const pageRef = useRef(1)

  const accountActivity = useAppSelector(state => state.loyalty.accountActivity)
  useEffect(() => {
    dispatch(fetchLoyaltyAccountActivity(startDate, endDate, 1))
  }, [dispatch])

  const loadMore = useCallback(() => {
    pageRef.current += 1
    dispatch(fetchLoyaltyAccountActivity(startDate, endDate, pageRef.current))
  }, [dispatch])

  return [
    accountActivity.data?.activities ?? EmptyArray,
    !!accountActivity.fetching,
    accountActivity.data?.hasNextPage ?? false,
    loadMore,
    accountActivity.error,
  ]
}

export default useCurrentLoyaltyActivities
